import { keepPreviousData } from '@tanstack/react-query';
import { AGGREGATE_NAMES, LOAN_REQUEST_RESOLVERS } from 'cpool-constants';
import { schemaLoanRequestResolver_GetAgreements } from 'cpool-tables/backend-resolvers';

import { useAggregateQuery } from '~/queryUtils/useQuery';
import { useQueryPositionStore } from '~/store/queryPositionStore';
import { queryKeys } from '~/utils/queryKeys';

const useAgreementsInfo = (id: string) => {
    const queryKey = queryKeys.getAgreements(id);
    const queryPosition = useQueryPositionStore((state) => state.positions[JSON.stringify(queryKey)]);

    const agreements = useAggregateQuery({
        acl: { loanRequestId: id },
        aggregateName: AGGREGATE_NAMES.LOAN_REQUEST,
        resolverName: LOAN_REQUEST_RESOLVERS.getAgreements,
        schema: schemaLoanRequestResolver_GetAgreements,
        searchParams: { id, position: queryPosition },
        tanstack: {
            placeholderData: keepPreviousData,
        },
    });

    return {
        agreementsInfo: agreements.data ? agreements.data : { applicant1: null, applicant2: null },
    };
};

export { useAgreementsInfo };
